<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <ApeMenu :menus="menus" />
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'

export default {
  name: 'GoalTrackingPerformance',
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      menus: [
        {
          icon: 'mubiao',
          display_name: '项目组',
          url: '/goal_tracking/objectives',
          permission_name: 'pa_kpi_prize__group'
        },
        {
          icon: 'fenpei',
          display_name: '总监',
          url: '/goal_tracking/director',
          permission_name: 'pa_kpi_prize__gm'
        },
        {
          icon: 'bangdan',
          display_name: 'VP',
          url: '/goal_tracking/vp',
          permission_name: 'pa_kpi_prize__vp'
        },
      ],
    }
  },
}
</script>

<style scoped></style>
